<template>
  <upload
    ref="upload"
    :file-id-before.sync="fileIdBeforeTemp"
    :props-data="{
      ...propsValue
    }"
  >
    <template v-slot:btn="{ progress }">
      <slot name="btn" :progress="progress"></slot>
    </template>
    <slot slot="tip" name="tip">
      <div v-if="!propsData.photoWall" class="important-tip m-l-10">
        支持pdf/doc/docx/xls/xlsx/ppt/pptx类型文件上传，word类型文件单个最大50MB；其他类型文件单个最大200MB；最多上传10个。
      </div>
    </slot>
  </upload>
</template>

<script>
// 组件
import Upload from '@/components/common/Upload/index'

import {
  getSuperviseUploadPolicy,
  getSuperviseFileListApi
} from '@/api/risk/supervise'

import { isArray } from '@/utils/type-check'

export default {
  name: 'SuperviseUpload',

  components: { Upload },

  props: {
    propsData: {
      type: Object,
      default: () => {}
    },

    fileIdBefore: {
      type: [String, Number, Array],
      default: ''
    }
  },

  computed: {
    fileIdBeforeTemp: {
      get() {
        return this.fileIdBefore || this.propsData.fileIdBefore
      },
      set(val) {
        this.$emit('update:fileIdBefore', val)
      }
    },

    // 传入jczh-ui的参数
    propsValue() {
      return Object.assign(
        {},
        {
          uploadMode: 'fileId',
          signatureApi: this.signatureApiTemp,
          getFileInfoByFileIdApi: this.getSuperviseFileList,
          getFileUrlByFileIdApi: this.getSuperviseFileUrl,
          fileListHiddenControl: {
            hiddenPreviewBtn: true
          }
        },
        this.propsData
      )
    }
  },

  methods: {
    // 获取凭证函数
    signatureApiTemp() {
      return new Promise((resolve, reject) => {
        getSuperviseUploadPolicy()
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            this.$message.error(err.message)
            reject()
          })
      })
    },

    // 获取附件url
    getSuperviseFileUrl({ attachmentId }) {
      return new Promise((resolve, reject) => {
        getSuperviseFileListApi({ attachmentCodes: attachmentId })
          .then(res => {
            const url = (res?.data[0] || {})?.url
            resolve(url)
          })
          .catch(err => {
            this.$message.error(err.message)
            reject()
          })
      })
    },

    // 查询附件
    getSuperviseFileList(data) {
      return new Promise((resolve, reject) => {
        const attachmentId = data.attachmentId
        if (!attachmentId) {
          resolve([])
        }
        getSuperviseFileListApi({
          attachmentCodes: isArray(attachmentId)
            ? (attachmentId || []).join(',')
            : attachmentId
        })
          .then(res => {
            const data = res.data || []
            const list = data.map(item => {
              return {
                attachmentId: item?.code || '',
                attachmentName: item?.name || '',
                external: item?.url || ''
              }
            })
            resolve({ data: list })
          })
          .catch(err => {
            this.$message.error(err.message)
            reject()
          })
      })
    },

    uploadComplete() {
      return this.$refs.upload?.$refs?.upload?.uploadComplete()
    },
    getFileList() {
      if (this.$refs.upload) {
        return this.$refs.upload?.$refs?.upload?.fileList || []
      }
      return []
    }
  }
}
</script>
